/*
 * @Author: peibao 1684413466@qq.com
 * @Date: 2023-05-04 09:27:07
 * @LastEditors: peibao 1684413466@qq.com
 * @LastEditTime: 2023-05-17 18:48:26
 * @FilePath: /xlian-business/src/api/business/company.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 添加子公司
  addCompany(data) {
    return request({
      url: `/business/company/add`,
      method: 'POST',
      data
    })
  },
  // 修改子公司
  updateCompany(data) {
    return request({
      url: `/business/company/updateCompanyInfo`,
      method: 'POST',
      data
    })
  },
  // 获取子公司列表
  getCompanyList(data) {
    return request({
      url: `/business/company/getCompanyList`,
      method: 'POST',
      data
    })
  },
  // 导出子公司列表
  exportCompanyList(data) {
    return request({
      url: `/business/company/export`,
      method: 'POST',
      data
    })
  },
  // 获取账号关联公司列表
  getPermissionCompany(data = {}) {
    return request({
      url: '/business/account/getPermissionCompany',
      method: 'POST',
      data
    })
  },
  // 有所属子公司返回子公司,总部:全部子公
  getCompanyForSelf(data = {}) {
    return request({
      url: '/business/company/getCompanyForSelf',
      method: 'POST',
      data
    })
  },
  // 企业可用积分查询
  businessUsableCredit(businessCode) {
    return request({
      url: `/businessCredit/usableCredit/${businessCode}`,
      method: 'get'
    })
  },
  // 获取标准科室一级科室
  getFirDept(data) {
    return request({
      url: '/business/businessDept/getDeptFirst',
      method: 'POST',
      data
    })
  },
  // 获取标准科室二级科室
  getSecDepts(data) {
    return request({
      url: '/business/businessDept/getDeptList',
      method: 'POST',
      data
    })
  },
  addDeptment(data) {
    return request({
      url: '/business/businessDept/addDept',
      method: 'POST',
      data
    })
  },
  // 编辑科室信息
  editFirDept(data) {
    return request({
      url: '/business/businessDept/updateDept',
      method: 'POST',
      data
    })
  },
  // 删除标准科室
  delStanDept(data) {
    return request({
      url: '/business/businessDept/deletedDept',
      method: 'POST',
      data
    })
  },
  // 省公司自动创建工作汇报开关
  getAutoSwitch(data) {
    return request({
      url: '/business/company/modifyWorkReportSwitch',
      method: 'POST',
      data
    })
  }
}
